



































































import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import LeaveConfirm from "@/components/dialogs/leaveConfirmDialog.vue";
import Tongue from "@/components/tongueFacePluse/tongue-basis.vue";
import Tongyong from "./details/tongyong.vue";
import {
  GetPatientInfo,
  GetLeftNav,
  PutUpdatePatient,
  GetTemplates,
  GetContents,
} from "@/request/cdr";
import { GetPatientPartDetail } from "@/request/hdr";
import DetailHeader from "./detail-header.vue";
import DetailLeftNav from "./detail-left-nav.vue";
import Gerenxinxi from "./details/gerenxinxi.vue";
import Custom from "./details/custom.vue";
import Shexiang from "../../../idr/views/patient-detail/details/shexiang-keyan/shexiang-keyan.vue";
import Mianxiang from "../../../idr/views/patient-detail/details/mianxiang/mianxiang.vue";
import Maixiang from "../../../idr/views/patient-detail/details/maixiang/maixiang.vue";
@Component({
  components: {
    LeaveConfirm,
    DetailHeader,
    DetailLeftNav,
    Gerenxinxi,
    Custom,
    Tongue,
    Tongyong,
    Shexiang,
    Mianxiang,
    Maixiang,
  },
})
export default class CdrPatientDetail extends Vue {
  private patient: any = {};
  private projectId: any = "";
  private groupId: any = "";
  private templateId: any = "";
  private nav: any[] = [];
  private cState: any = "个人信息";
  private message: any = {};
  private loaded: boolean = false;
  private ifShowLeaveConfirm: boolean = false;
  private ifShowNavChangeConfirm: boolean = false;
  private templates: any = [];
  private contents: any = [];
  private targetPart: any = {};
  @Watch("$route.query", { immediate: true })
  private queryChange(query: any) {
    this.init();
  }

  private get ifCompose() {
    return this.$store.state.cdrIfCompose;
  }

  /**
   * @description 跳转
   */
  private jump(part) {
    this.$router.replace({
      path: "/main/cdr/patient-detail",
      query: {
        patient_id: this.patient.patient_id,
        project_id: this.projectId,
        group_id: this.groupId,
        template_name: part["名称"],
        template_id: part["template_id"],
      },
    });
  }
  /**
   * @description 获得患者基本信息
   */
  private fetchPatient() {
    const params = {
      params: {
        patient_id: this.patient.patient_id,
        project_id: this.projectId,
        group_id: this.groupId,
      },
    };
    GetPatientInfo(this, params).then((data: any) => {
      this.patient = data;
    });
  }
  /**
   * @description 获取右侧详细模板信息
   */
  private fetchTemplate() {
    this.loaded = false;
    return new Promise((resolve, reject) => {
      if (
        this.cState === "舌象数据-科研版" ||
        this.cState === "面象数据" ||
        this.cState === "脉象数据"
      ) {
        let arg: string = "";
        switch (this.cState) {
          case "舌象数据-科研版":
            arg = "舌象科研";
            break;
          default:
            arg = this.cState;
        }
        GetPatientPartDetail(this, this.patient.patient_id, arg).then(
          (data: any) => {
            this.message = data;
            this.loaded = true;
          }
        );
        reject("舌面脉数据");
      } else {
        const params: any = {
          params: {
            template_id: this.templateId,
          },
        };
        GetTemplates(this, params).then((data: any) => {
          this.templates = data;
          resolve();
        });
      }
    });
  }
  /**
   * @description 获取右侧数据详情
   */
  private fetchContents() {
    const params: any = {
      params: {
        patient_id: this.patient.patient_id,
        project_id: this.projectId,
        group_id: this.groupId,
        template_id: this.templateId,
      },
    };
    GetContents(this, params).then((data: any) => {
      this.contents = data;
      this.loaded = true;
    });
  }
  /**
   * @description 获得左侧列表
   */
  private fetchLeftNav() {
    const params: any = {
      params: {
        patient_id: this.patient.patient_id,
        project_id: this.projectId,
        group_id: this.groupId,
      },
    };
    GetLeftNav(this, params).then((data: any) => {
      this.nav = data;
    });
  }
  /**
   * @description 修改个人信息
   */
  private saveInfo() {
    return new Promise((resolve, reject) => {
      if (!this.patient["姓名"]) {
        this.$message.warning("姓名必须填写");
        reject();
        return;
      }
      if (!this.patient["性别"]) {
        this.$message.warning("性别必须填写");
        reject();
        return;
      }
      if (!this.patient["身份证号"]) {
        this.$message.warning("身份证或唯一标识符必须填写");
        reject();
        return;
      }
      if (!this.patient["出生日期"]) {
        this.$message.warning("出生日期必须填写");
        reject();
        return;
      }
      if (!this.patient["hospital_id"]) {
        this.$message.warning("所属机构必须填写");
        reject();
        return;
      }
      this.patient.group_id = this.groupId;
      this.patient.project_id = this.projectId;
      PutUpdatePatient(this, this.patient)
        .then((data: any) => {
          this.$message.success("修改成功");
          this.$store.commit("updateCdrIfCompose", false);
          resolve();
        })
        .catch(() => {
          reject();
        });
    });
  }
  /**
   * @description 左侧导航切换需要
   */
  private leftNeedSave(part) {
    this.targetPart = part;
    this.ifShowNavChangeConfirm = true;
  }

  /**
   * @description 离开保存
   */
  private leaveSave() {
    this.ifShowLeaveConfirm = false;
    if (this.cState === "个人信息") {
      this.saveInfo().then(() => {
        this.$router.push("/main/cdr/patient-list");
      });
    } else {
      (this.$refs.custom as any).save().then(() => {
        this.$router.push("/main/cdr/patient-list");
      });
    }
  }
  /**
   * @description 不保存离开
   */
  private leaveConfirmed() {
    this.$store.commit("updateCdrIfCompose", false);
    this.$router.push("/main/cdr/patient-list");
  }
  /**
   * @description 导航切换保存
   */
  private navChangeSave() {
    this.ifShowNavChangeConfirm = false;
    if (this.cState === "个人信息") {
      this.saveInfo().then(() => {
        this.jump(this.targetPart);
      });
    } else {
      (this.$refs.custom as any).save().then(() => {
        this.jump(this.targetPart);
      });
    }
  }
  /**
   * @description 导航切换不保存离开
   */
  private navChangeConfirmed() {
    this.ifShowNavChangeConfirm = false;
    this.$store.commit("updateCdrIfCompose", false);
    this.jump(this.targetPart);
  }
  /**
   * @description 初始化函数
   */
  private init() {
    this.patient.patient_id = this.$route.query.patient_id;
    this.projectId = this.$route.query.project_id;
    this.groupId = this.$route.query.group_id;
    this.cState = this.$route.query.template_name
      ? this.$route.query.template_name
      : "个人信息";
    if (!this.patient.patient_id || !this.projectId || !this.groupId) {
      this.$message.error("参数不全，请重新进入");
      this.$router.back();
      return;
    }
    if (this.$route.query.template_id) {
      this.templateId = this.$route.query.template_id;
      this.fetchTemplate()
        .then(() => {
          this.fetchContents();
        })
        .catch((err) => {
          console.log(err);
        });
    }
    this.fetchLeftNav();
    this.fetchPatient();
  }
  /**
   * @description 离开页面前保存
   */
  private beforeRouteLeave(to, from, next) {
    if (this.ifCompose) {
      this.ifShowLeaveConfirm = true;
      next(false);
    } else {
      next(true);
    }
  }
}
